/**
 * DeviceInfo — central, single-source-of-truth device classification.
 * Evaluated once at module load; stays constant for the session lifetime.
 */
export class DeviceInfo {
    private static _mobile: boolean | null = null;

    /** True when running on a mobile phone or small tablet with touch. */
    static get isMobile(): boolean {
        if (DeviceInfo._mobile === null) {
            if (typeof window === 'undefined') {
                DeviceInfo._mobile = false;
            } else {
                const BREAKPOINT = 768;
                const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
                const isSmall = window.innerWidth < BREAKPOINT;
                const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                DeviceInfo._mobile = hasTouch && (isSmall || mobileUA);
            }
        }
        return DeviceInfo._mobile;
    }

    /** True on desktop / large screens without primary touch input. */
    static get isDesktop(): boolean {
        return !DeviceInfo.isMobile;
    }
}
